<div [ngClass]="{'mt-[15px]': isSmall}" 
[ngClass]="{'hidden lg:block': hideOnMobile}" >
    <p-breadcrumb ngSkipHydration [model]="this.items()" class="custom-breadcrub" >
        <ng-template #item let-item>
            <a class="cursor-pointer whitespace-nowrap overflow-scroll" [attr.href]="item.url || null" 
            [ngClass]="{
                'text-[12px] ': isSmall,
                'text-[16px] ': !isSmall,
                'text-[rgba(128,130,133,1)]':isColorLight,
                'text-[rgba(74,74,74,1)]':!isColorLight,
                'font-mulish': isFontMulish,
                'DMSans': !isFontMulish
            }">
                {{item.label}} <span *ngIf="item.resultsNumber" class="font-semibold"> ({{item.resultsNumber}}<span *ngIf="resultsText" class="font-semibold"> results</span>)</span>
            </a>
        </ng-template>
        <ng-template #separator>
            <fa-icon *ngIf="separatorIsChevron" [icon]="faChevronRight" 
            class="inline-flex items-center mt-[4px]"
            [ngClass]="{
                'text-[12px]': isSmall,
                'text-[16px]': !isSmall,
                'text-[rgba(128,130,133,1)]':isColorLight,
                'text-[rgba(74,74,74,1)]':!isColorLight
            }"/>
            <div *ngIf="!separatorIsChevron"
            [ngClass]="{
                'text-[12px]': isSmall,
                'text-[16px]': !isSmall,
                'text-[rgba(128,130,133,1)]':isColorLight,
                'text-[rgba(74,74,74,1)]':!isColorLight
            }">
                {{separatorCharacter}}
            </div>
        </ng-template>
    </p-breadcrumb>
</div>

